export const HOSTING_CONFIG = {
  ANDROID_DOMAIN: 'dietaiapp.com',
  IOS_DOMAIN: 'foodaiapp.com',
  ANDROID_APP_NAME: 'DietAI',
  IOS_APP_NAME: 'Food AI',
  ANDROID_CAMPAIGN_LINK_ID: 'dietaiplan.calorietracker.app',
  ANDROID_CAMPAIGN_LINK_SOURCE: 'web',
  ANDROID_CAMPAIGN_LINK_MEDIUM: 'social',
  ANDROID_CAMPAIGN_LINK_CAMPAIGN: 'get_web',
  IOS_CAMPAIGN_LINK_ID: '6711353848',
  IOS_CAMPAIGN_LINK_PT: '122493419',
  IOS_CAMPAIGN_LINK_CT: 'get_web',
  IOS_CAMPAIGN_LINK_MT: '8',
}
